import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-503f3322")

_pushScopeId("data-v-503f3322")
const _hoisted_1 = { class: "sys-table__headers" }
const _hoisted_2 = {
  class: "sys-table__headers--fixed",
  ref: "headersFixed"
}
const _hoisted_3 = {
  key: 2,
  class: "truncate w-100 text-center"
}
const _hoisted_4 = { class: "flex justify-start" }
const _hoisted_5 = {
  class: "sys-table__body--flexible",
  ref: "bodyFlexible"
}
const _hoisted_6 = {
  class: "effect-horizontal-scroll",
  ref: "effectHorizontal"
}
const _hoisted_7 = {
  class: "effect-vertical-scroll",
  ref: "effectVertical"
}
const _hoisted_8 = {
  key: 0,
  class: "scroll-bar",
  id: "scroll-bar",
  ref: "scrollThumb"
}
const _hoisted_9 = { class: "text-center py-2 pagination" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Pagination = _resolveComponent("Pagination")

  return (_openBlock(), _createBlock(_Fragment, null, [
    ($props.headers.length)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["sys-table relative", $props.classes]
        }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.fixedLeft, (itemFixed, indexFixed) => {
                return (_openBlock(), _createBlock("div", {
                  key: 'headerFixed' + $props.headers[indexFixed].value,
                  class: "item-header truncate",
                  style: { width: $props.headers[indexFixed].width + 'px' }
                }, [
                  _renderSlot(_ctx.$slots, $props.headers[indexFixed].value, {
                    item: $props.headers[indexFixed],
                    index: indexFixed
                  }, () => [
                    ($props.headers[indexFixed].value == 'checkbox')
                      ? (_openBlock(), _createBlock(_component_Checkbox, {
                          key: 0,
                          class: "justify-center",
                          modelValue: $setup.checkAll,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.checkAll = $event)),
                          onChange: $setup.handleClickAll
                        }, null, 8, ["modelValue", "onChange"]))
                      : ($props.headers[indexFixed].type === 'html')
                        ? (_openBlock(), _createBlock("div", {
                            key: 1,
                            innerHTML: $props.headers[indexFixed].text
                          }, null, 8, ["innerHTML"]))
                        : (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString($props.headers[indexFixed].text), 1))
                  ], true)
                ], 4))
              }), 128))
            ], 512),
            _createVNode("div", {
              class: "sys-table__headers--flexible",
              ref: "headersFlexible",
              id: $props.uniqueTable + 'sys-table__headers--flexible'
            }, [
              _createVNode("div", _hoisted_4, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.headers.length - $props.fixedLeft, (itemHeader, indexHeader) => {
                  return (_openBlock(), _createBlock("div", {
                    key: 'headerFixed' + $props.headers[indexHeader].value,
                    class: "item-header",
                    style: {
              width: $props.headers[indexHeader + $props.fixedLeft].width + 'px',
              'min-width': $props.headers[indexHeader + $props.fixedLeft].width + 'px',
            }
                  }, [
                    _renderSlot(_ctx.$slots, $props.headers[indexHeader + $props.fixedLeft].value, {
                      item: $props.headers[indexHeader + $props.fixedLeft],
                      index: indexHeader
                    }, () => [
                      ($props.headers[indexHeader + $props.fixedLeft].type === 'html')
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            innerHTML: $props.headers[indexHeader + $props.fixedLeft].text
                          }, null, 8, ["innerHTML"]))
                        : (_openBlock(), _createBlock("div", {
                            key: 1,
                            class: ["w-100 text-center", [$props.truncateHeaderClass]]
                          }, _toDisplayString($props.headers[indexHeader + $props.fixedLeft].text), 3))
                    ], true)
                  ], 4))
                }), 128))
              ])
            ], 8, ["id"])
          ]),
          _createVNode("div", {
            class: "sys-table__body",
            onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.onScrollVertical && $setup.onScrollVertical(...args))),
            ref: "bodyTable"
          }, [
            _createVNode("div", {
              class: "sys-table__body--fixed",
              ref: "bodyRowFixed",
              style: $props.isFixed ? `margin-bottom: ${$props.paddingToShowElement}px` : ''
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.data, (row, indexRow) => {
                return (_openBlock(), _createBlock("div", {
                  key: 'headerFixed' + $props.data[indexRow].value,
                  class: "row-fixed"
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.fixedLeft, (cell, indexCell) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "cell-data flex items-center",
                      key: 'cell' + indexCell,
                      style: {
              width: $props.headers[indexCell].width + 'px',
              justifyContent:
                $props.headers[indexCell + $props.fixedLeft]?.justify || 'center',
            }
                    }, [
                      _renderSlot(_ctx.$slots, 'data-' + $props.headers[indexCell].value, {
                        item: $props.data[indexRow][$props.headers[indexCell].value],
                        index: indexRow,
                        dataRow: $props.data[indexRow]
                      }, () => [
                        ($props.headers[indexCell].value == 'checkbox')
                          ? (_openBlock(), _createBlock(_component_Checkbox, {
                              key: 0,
                              class: "justify-center w-full",
                              modelValue: $setup.checkListItem,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.checkListItem = $event)),
                              value: $props.data[indexRow][$props.itemText]
                            }, null, 8, ["modelValue", "value"]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: ["truncate w-100 text-center", $props.headers[indexCell].bodyClass]
                            }, _toDisplayString($props.data[indexRow][$props.headers[indexCell].value]), 3))
                      ], true)
                    ], 4))
                  }), 128))
                ]))
              }), 128))
            ], 4),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", {
                class: "flex justify-start overflow-x-auto max-w-full sys-table__body--flexible-row",
                id: $props.uniqueTable + 'sys-table__body--flexible-row',
                style: [{"flex-direction":"column"}, $props.isFixed ? `padding-bottom: ${$props.paddingToShowElement}px` : ''],
                ref: "bodyRowFlexible",
                onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.onScrollRow && $setup.onScrollRow(...args)))
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.data, (row, indexRow) => {
                  return (_openBlock(), _createBlock("div", {
                    key: 'headerFixed' + $props.data[indexRow].value,
                    class: "row-flexible",
                    ref: $props.itemsPerPages == indexRow + 1 ? 'lastElementInit' : ''
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.headers.length - $props.fixedLeft, (cell, indexCell) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "cell-data flex items-center break-all",
                        key: 'cell' + indexCell,
                        style: {
                width: $props.headers[indexCell + $props.fixedLeft].width + 'px',
                'min-width': $props.headers[indexCell + $props.fixedLeft].width + 'px',
                justifyContent:
                  $props.headers[indexCell + $props.fixedLeft]?.justify || 'center',
              }
                      }, [
                        _renderSlot(_ctx.$slots, 'data-' + $props.headers[indexCell + $props.fixedLeft].value, {
                          item: 
                  $props.data[indexRow][$props.headers[indexCell + $props.fixedLeft].value]
                ,
                          index: indexRow,
                          dataRow: $props.data[indexRow]
                        }, () => [
                          _createVNode("div", {
                            class: ["truncate w-100 text-center", [$props.headers[indexCell + $props.fixedLeft].bodyClass, '']]
                          }, _toDisplayString($props.data[indexRow][$props.headers[indexCell + $props.fixedLeft].value]), 3)
                        ], true)
                      ], 4))
                    }), 128))
                  ], 512))
                }), 128))
              ], 44, ["id"])
            ], 512)
          ], 544),
          _createVNode("div", _hoisted_6, null, 512),
          _createVNode("div", _hoisted_7, null, 512),
          _createVNode("div", {
            class: "scroll-bar-horizontal",
            id: $props.uniqueTable + 'scroll-bar-horizontal',
            ref: "scrollHorizontal",
            onScroll: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.onScrollHorizontal && $setup.onScrollHorizontal(...args)))
          }, [
            ($props.data.length)
              ? (_openBlock(), _createBlock("div", _hoisted_8, " . ", 512))
              : _createCommentVNode("", true)
          ], 40, ["id"])
        ], 2))
      : _createCommentVNode("", true),
    (!$props.data.length)
      ? _renderSlot(_ctx.$slots, "no-data", { key: 1 }, () => [
          _createVNode("div", {
            class: "text-center py-4 no-data-table",
            style: { width: $setup.noData + 'px', maxWidth: '100%' }
          }, _toDisplayString($setup.t('thereIsNoData')), 5)
        ], {}, true)
      : _createCommentVNode("", true),
    ($props.isPagination && $props.currentPage && $props.recordTotal)
      ? _renderSlot(_ctx.$slots, "pagination", { key: 2 }, () => [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Pagination, {
              pageActive: $setup.pageActive,
              "onUpdate:pageActive": _cache[6] || (_cache[6] = ($event: any) => ($setup.pageActive = $event)),
              perPage: $setup.itemPerPagesValue,
              "onUpdate:perPage": _cache[7] || (_cache[7] = ($event: any) => ($setup.itemPerPagesValue = $event)),
              "show-item-per-page": $props.showItemPerPage,
              totalItem: $props.recordTotal,
              onChangePage: $setup.onChangePage
            }, null, 8, ["pageActive", "perPage", "show-item-per-page", "totalItem", "onChangePage"])
          ])
        ], {}, true)
      : _createCommentVNode("", true)
  ], 64))
})